import { render, staticRenderFns } from "./businesstrips.vue?vue&type=template&id=d48f5ef0&scoped=true"
import script from "./businesstrips.vue?vue&type=script&lang=js"
export * from "./businesstrips.vue?vue&type=script&lang=js"
import style0 from "./businesstrips.vue?vue&type=style&index=0&id=d48f5ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48f5ef0",
  null
  
)

export default component.exports